import { render, staticRenderFns } from "./productScreening.vue?vue&type=template&id=7d8090d9&scoped=true&"
import script from "./productScreening.vue?vue&type=script&lang=js&"
export * from "./productScreening.vue?vue&type=script&lang=js&"
import style0 from "./productScreening.vue?vue&type=style&index=0&id=7d8090d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8090d9",
  null
  
)

export default component.exports